export default function SocialProof() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-14">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
        {/* Left: Testimonial */}
        <div className="w-full lg:w-3/5">
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-foreground-400"></span>
            Verified Review
          </span>

          <blockquote className="mt-8 font-heading text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-950 leading-relaxed tracking-tight">
            &ldquo;Superbuy Spreadsheet completely changed how I shop online. Instead of jumping between dozens of websites, I can browse everything in one organized place. The product categories are intuitive and the guides actually help me make better decisions.&rdquo;
          </blockquote>

          <div className="mt-8 flex items-center gap-3">
            <div>
              <p className="text-sm font-label font-semibold text-foreground-950">Marcus Reed</p>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500 w-3 h-3 flex items-center justify-center"></i>
                  ))}
                </div>
                <span className="text-xs text-foreground-400">Verified Shopper</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Portrait */}
        <div className="w-full lg:w-2/5">
          <div className="w-full h-[300px] md:h-[400px] lg:h-[500px] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20man%20with%20slight%20smile%20looking%20directly%20at%20camera%2C%20natural%20window%20light%20from%20right%2C%20clean%20warm%20cream%20background%2C%20casual%20yet%20polished%20style%20wearing%20simple%20neutral%20toned%20sweater%2C%20editorial%20portrait%20photography%2C%20warm%20natural%20tones%2C%20soft%20focus%20background%2C%20genuine%20approachable%20expression%2C%20minimal%20makeup%20style%2C%20half%20body%20composition&width=500&height=650&seq=testimonial-portrait-v2&orientation=portrait"
              alt="Verified shopper testimonial for Superbuy Spreadsheet"
              title="Superbuy Spreadsheet verified shopper"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}